import React, { useEffect, useState } from 'react';
import { FormikErrors } from 'formik';
import { AuthMarketing, Button, FieldWrapper, FormError, LayoutSplit } from 'components';
import { DOBInput, RecoveryPinInput } from 'components/Input';
import { ICreateAccountRecovery } from 'types';
import { AuthContainer, AuthContent, AuthContentInner, AuthFieldset } from '../Auth/styles';

interface IAccountRecoveryProps {
  authHeader: JSX.Element;
  onSubmit: () => void;
  formId: string;
  errors: FormikErrors<ICreateAccountRecovery>;
  validateField: (field: 'recoveryPin' | 'dateOfBirth') => boolean;
  isLoading: boolean;
  getFieldProps: (fieldName: string) => any;
  setFieldValue: (fieldName: string, value: any) => void;
  isValid: boolean;
  dirty: boolean;
  values: Record<string, any>;
  errorMessages: string[];
  handleBlur: (e: Event) => void;
  hasDob?: boolean;
  hasPin?: boolean;
}

const AccountRecovery = ({ authHeader, onSubmit, errors, validateField, isLoading, getFieldProps, errorMessages, isValid, dirty, hasDob, hasPin }: IAccountRecoveryProps) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (errorMessages && errorMessages.length > 0) {
      setShowError(true);
    }
  }, [errorMessages]);

  return (
    <LayoutSplit
      left={
        <AuthContainer>
          <AuthContent data-cy="account-recovery--page-1">
            <AuthContentInner>
              {authHeader}
              <form onSubmit={onSubmit} onChange={() => setShowError(false)}>
                <AuthFieldset>
                  {hasDob && (
                    <FieldWrapper data-cy="date-of-birth-field" label="Date of Birth" message={validateField('dateOfBirth') ? errors.dateOfBirth : ''} hasError={validateField('dateOfBirth')}>
                      <DOBInput id="dateOfBirth" disabled={isLoading} type="text" placeholder="MM-DD-YYYY" {...getFieldProps('dateOfBirth')} />
                    </FieldWrapper>
                  )}
                  {hasPin && (
                    <FieldWrapper data-cy="recovery-pin-field" label="Recovery Pin" message={validateField('recoveryPin') ? errors.recoveryPin : ''} hasError={validateField('recoveryPin')}>
                      <RecoveryPinInput id="recoveryPin" disabled={isLoading} type="text" placeholder="4 digit pin code" {...getFieldProps('recoveryPin')} />
                    </FieldWrapper>
                  )}
                </AuthFieldset>

                {errorMessages &&
                  showError &&
                  errorMessages.map((error: string, index: number) => (
                    <FormError data-cy="form-error" key={`error-message-${index}`}>
                      {error}
                    </FormError>
                  ))}

                <Button data-cy="submit-button" type="submit" label="Continue" disabled={!hasDob && !hasPin ? false : isLoading || !(isValid && dirty)} isProcessing={isLoading} />
              </form>
            </AuthContentInner>
          </AuthContent>
        </AuthContainer>
      }
      right={<AuthMarketing />}
    />
  );
};

export default AccountRecovery;
